// extracted by mini-css-extract-plugin
module.exports = {"breakPointDesktop":"1024px","blackText":"#121212","whiteText":"#fff"};